import { createContextFactory } from '@streem/toolbox';
export const [CompanyInfoProvider, useCompanyInfo] = createContextFactory('CompanyInfo');
//# sourceMappingURL=company_info.js.map